(function(){
  // ─── Property name cleanup map ───────────────────────────────────────────
  // Strips _2_io_duplicate suffix and normalises display names
  var RENAME_MAP = {
    'Scalp Material Colour_2_io_duplicate': 'Scalp Material Color',
    'Texture_2_io_duplicate': 'Texture',
    'Scalp Material Color_2_io_duplicate': 'Scalp Material Color',
    'Scalp Material Colour': 'Scalp Material Color'
  };

  // Properties that should be completely hidden from cart/checkout display
  var HIDE_PROPS = ['colour category', 'color category'];

  function cleanupCart(){
    document.querySelectorAll('li, p, dd, dt, span, div, tr, td').forEach(function(el){
      // Only process leaf-ish elements (skip containers with many children)
      if (el.children.length > 3) return;

      var text = (el.textContent || '').trim();

      // ── Hide unwanted properties ──────────────────────────────────────
      for (var i = 0; i < HIDE_PROPS.length; i++) {
        if (text.toLowerCase().indexOf(HIDE_PROPS[i] + ':') === 0 ||
            text.toLowerCase() === HIDE_PROPS[i]) {
          var hideTarget = el.closest('li, tr, .cart-item__property, [class*="property"]') || el;
          hideTarget.style.display = 'none';
          return;
        }
      }

      // ── Rename ugly IO property names ─────────────────────────────────
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while (node = walker.nextNode()) {
        var orig = node.nodeValue;
        var updated = orig;
        for (var ugly in RENAME_MAP) {
          if (updated.indexOf(ugly) !== -1) {
            updated = updated.split(ugly).join(RENAME_MAP[ugly]);
          }
        }
        // Catch any remaining _N_io_duplicate suffixes
        updated = updated.replace(/_\d*_?io_duplicate/gi, '');
        if (updated !== orig) {
          node.nodeValue = updated;
        }
      }

      // ── Bold Client Name ──────────────────────────────────────────────
      if (/^client name:/i.test(text)) {
        var boldTarget = el.closest('li, tr, .cart-item__property, [class*="property"]') || el;
        boldTarget.style.fontWeight = 'bold';
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', cleanupCart);
  else cleanupCart();
  new MutationObserver(cleanupCart).observe(document.body, { childList: true, subtree: true });
})();
